module.exports = __webpack_public_path__ + "bot2.1fefbc7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/bot2.png
// module id = 1585
// module chunks = 0